import { render, staticRenderFns } from "./StatusRegionItem.vue?vue&type=template&id=ce89cdc6&scoped=true&"
import script from "./StatusRegionItem.vue?vue&type=script&lang=js&"
export * from "./StatusRegionItem.vue?vue&type=script&lang=js&"
import style0 from "./StatusRegionItem.vue?vue&type=style&index=0&id=ce89cdc6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce89cdc6",
  null
  
)

export default component.exports